import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static values = {
    name: String,
  };

  connect() {
    this.element.classList.add(this.nameValue);

    this.element.addEventListener("animationend", () => this.element.classList.remove(this.nameValue), { once: true });
  }
}
